import React, { Component, Fragment } from 'react';
import { FullscreenImage } from '../components/FullscreenImage';
import NavMenu from '../components/NavMenu';
import options from "../containers/MusicPlayerOptions";
import ReactPlayer from 'react-player';

class StandardPage extends Component {
  details = this.props.inputData;

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  isYouTube(url) {
    return url.includes('youtube.com') || url.includes('youtu.be');
  }

  isYouTubePlaylist(url) {
    return this.isYouTube(url) && url.includes('list=');
  }

 getYouTubePlaylistEmbed(url) {
  try {
    const params = new URL(url).searchParams;
    const listId = params.get('list');

    return listId
      ? `https://www.youtube.com/embed/videoseries?list=${listId}`
      : null;
  } catch {
    return null;
  }
}

  renderMediaItem(item) {
    const { id, url } = item;
    if (!url) return null;

    // YouTube playlists → iframe embed
    if (this.isYouTubePlaylist(url)) {
      const embedUrl = this.getYouTubePlaylistEmbed(url);
      return embedUrl ? (
        <li key={id} className="flex p-2">
          <iframe
            width="560"
            height="315"
            src={embedUrl}
            title="YouTube playlist"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </li>
      ) : null;
    }

    // Everything else ReactPlayer supports
    if (ReactPlayer.canPlay(url)) {
      return (
        <li key={id} className="flex p-2">
          <ReactPlayer url={url} />
        </li>
      );
    }

    return null;
  }

  render() {
    return (
      <Fragment>
        <FullscreenImage image={`../images/${this.details.image}`}>
          <NavMenu menuList={this.props.menuList} musicParams={options} />
          <div className="ml-5 pt-5 w-1/3 font-sans text-white">
            <h1 className="mb-5 uppercase tracking-wide font-thin text-5xl">
              {this.details.title}
            </h1>
            <p className="tracking-wide font-hairline md:text-2xl text-sm">
              {this.details.subtitle}
            </p>
          </div>
        </FullscreenImage>

        <h1 className="text-center font-sans font-thin mt-6">
          {this.details.title}
        </h1>

        {/* Copy with HTML links */}
      <div
  className="text-justify font-thin bg-white p-8 md:px-20 md:mx-32 whitespace-pre-wrap"
  dangerouslySetInnerHTML={{ __html: this.details.copy }}
/>


        <div className="md:flex justify-center md:mx-32 mx-12 mb-24 mt-16">
          <ul className="md:flex p-0">
            {Array.isArray(this.props.media) &&
              this.props.media.map(item => this.renderMediaItem(item))}
          </ul>
        </div>
      </Fragment>
    );
  }
}

export default StandardPage;
